import { Store } from "pullstate";
import { UserDetailDto, UserDto } from "../clients/userApiClient";
export interface IActiveOrganisation {
    id: number,
    name: string
}

export const AuthStore = new Store({
    authSettings: {
        jwtToken: window.localStorage.getItem("jwt"),
        email: "",
        name: "",
        newUser : false,
        role : false
    } as AuthObj,
});

export interface AuthObj{
    jwtToken: string,
    email: string,
    name: string,
    newUser : boolean,
    role : boolean,
}
export const UserStore = new Store({
    user : undefined as UserDetailDto
})